import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EZYNESSADMIN_ROUTE_PROVIDER } from './ezyness-admin-route.provider';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [],
})
export class EzynessAdminConfigModule {
  static forRoot(): ModuleWithProviders<EzynessAdminConfigModule> {
    return {
      ngModule: EzynessAdminConfigModule,
      providers: [EZYNESSADMIN_ROUTE_PROVIDER],
    };
  }
}
